import { render } from "./slider.vue?vue&type=template&id=41b74916"
import script from "./slider.vue?vue&type=script&lang=js"
export * from "./slider.vue?vue&type=script&lang=js"

import "./slider.vue?vue&type=style&index=0&id=41b74916&lang=css"
script.render = render

export default script